export class Mouse {
  constructor() {
    this.init();
  }
  init() {
    const rats = document.querySelectorAll('.rat')

    rats.forEach((rat) => {

      const mouse = rat.parentNode

      mouse.style.animationDelay = Math.floor(Math.random() * 250) + "ms";
      rat.style.animationDelay = Math.floor(Math.random() * 300) + "ms";

      setTimeout(() => {
        rat.style.animationDuration = "0.4s"
      }, 1300)
      setTimeout(() => {
        rat.style.animationDuration = "0.2s"
      }, 2300)
    })

    setInterval(() => {
      rats.forEach((rat) => {
        const mouse = rat.parentNode

        mouse.style.animationDelay = Math.floor(Math.random() * 250) + "ms";
        rat.style.animationDelay = Math.floor(Math.random() * 300) + "ms";
        setTimeout(() => {
          rat.style.animationDuration = "0.4s"
        }, 1300)
        setTimeout(() => {
          rat.style.animationDuration = "0.2s"
        }, 2300)
      })
    }, 4000)
  }
}
